import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  signal,
} from '@angular/core';
import { BoelsUserTypeEnum } from '@boels/models';
import { TranslocoModule } from '@jsverse/transloco';
import { UserTypeService, BreakpointService } from '@boels/helpers';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faUser, faUserTie } from '@fortawesome/free-solid-svg-icons';

@Component({
  imports: [NgClass, TranslocoModule, FaIconComponent],
  selector: 'boels-toggle-user-type',
  templateUrl: './toggle-user-type.component.html',
  styleUrls: ['./toggle-user-type.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToggleUserTypeComponent {
  userTypeEnum = BoelsUserTypeEnum;
  userTypeService = inject(UserTypeService);
  breakpointService = inject(BreakpointService);
  faUserTie = faUserTie;
  faUser = faUser;

  readonly userType = signal(this.userTypeService.getUserType());
  readonly mdAndBelow = toSignal(this.breakpointService.mdAndBelow$, {
    initialValue: false,
  });

  @HostBinding('class') get toggleUserTypeClass() {
    return !this.mdAndBelow ? '-mobile' : '-desktop';
  }

  constructor() {
    this.userTypeService
      .onUserTypeChange()
      .pipe(takeUntilDestroyed())
      .subscribe((type) => {
        this.userType.set(type);
      });
  }

  setUserType(type: BoelsUserTypeEnum, activeType: string | undefined): void {
    if (!type || activeType !== type) {
      this.userTypeService.setUserType(type);
    }
  }

  getMobileIcon(): typeof faUser | typeof faUserTie {
    return this.userType() === this.userTypeEnum.BUSINESS
      ? this.faUserTie
      : this.faUser;
  }
}
